import { createSlice } from "@reduxjs/toolkit";
import {
  AddRelationshipAction,
  DeleteRelationshipAction,
  GetAllRelationshipAction,
  UpdateRelationshipAction,
} from "store/middlewares/dataManagement/relationship";

// isDeleteMeFulFilled
export const relationshipSlice = createSlice({
  name: "relationship",
  initialState: {
    relationshipLoading: true,
    relationship: null,
  },
  extraReducers(builder) {
    builder
      .addCase(GetAllRelationshipAction.pending, (state) => {
        // state.relationshipLoading = true;
        // state.relationship = null;
        state.relationship =
          state.relationship?.data?.length > 0 ? state.relationship : null;
      })
      .addCase(GetAllRelationshipAction.fulfilled, (state, action) => {
        state.relationshipLoading = false;
        state.relationship = action.payload.response;
      })
      .addCase(GetAllRelationshipAction.rejected, (state) => {
        state.relationshipLoading = false;
        state.relationship = null;
      })
      // Delete
      .addCase(DeleteRelationshipAction.fulfilled, (state, action) => {
        // state.relationshipLoading = false;
        // state.relationship = {
        //   ...state.relationship,
        //   total: Number(state.relationship.total) - 1,
        //   data: state.relationship?.data?.filter(
        //     (item) => item.id !== action.payload.id
        //   ),
        // };
        state.relationshipLoading = false;
        state.relationship = action.payload.response;
      })
      //Update
      .addCase(UpdateRelationshipAction.fulfilled, (state, action) => {
        state.relationshipLoading = false;
        state.relationship = {
          ...state.relationship,
          data: state.relationship.data.map((item) =>
            item.id === action.payload.response.id
              ? action.payload.response
              : item
          ),
        };
      })

      //Add
      .addCase(AddRelationshipAction.fulfilled, (state, action) => {
        // state.relationshipLoading = false;
        // state.relationship = {
        //   ...state.relationship,
        //   total: Number(state.relationship.total) + 1,
        //   data: [action.payload.response, ...state.relationship.data],
        // };
        state.relationshipLoading = false;
        state.relationship = action.payload.response;
      });
  },
});

export default relationshipSlice.reducer;
